import { TENANTS } from "../../constants"
import React from "react"

export const withUpdatedTunnelData = (WrappedPage, tunnelData, packContext) => {
  return (props) => {
    const isBPLS = tunnelData.tenant === TENANTS.RETAIL_BPLS || tunnelData.tenant === TENANTS.BPLS
    const products = packContext?.packs?.slice(-1)?.[0] || tunnelData?.data?.order?.products
    const onlyServicePackList = packContext?.packs?.slice(0, -1)

    const packContextForBasket = {
      isRetail: true,
      product: products,
      packContext: onlyServicePackList
    }

    const filterSelectedRentDuration = (packList) => {
      const rent = packList?.filter((pack) => pack?.rentDTO?.duration === tunnelData?.data?.order?.durationMonth)
      return rent?.[0]?.rentDTO
    }

    const packToTunnelData = (pack) => {
      const rentDTO = filterSelectedRentDuration(pack?.packContext)

      if (!isBPLS) {
        return tunnelData
      }
      return {
        ...tunnelData,
        data: {
          order: {
            orderLanguageTag: tunnelData.lang,
            promotionDTOs: [],
            rent: rentDTO,
            products: products
          },
          quantity: products?.length
        },
        displayHeaderPrice: tunnelData?.displayHeaderPrice,
        displayBasketQuantity: tunnelData?.displayBasketQuantity,
        displayotherInformationsBasket: tunnelData?.displayotherInformationsBasket,
        tenant: tunnelData?.tenant
      }
    }
    
    return <WrappedPage {...props} packContext={packContext} tunnelData={packToTunnelData(packContextForBasket)} />
  }
}
